import { render } from "./SelectButton.vue?vue&type=template&id=0bac8b17"
import script from "./SelectButton.vue?vue&type=script&lang=js"
export * from "./SelectButton.vue?vue&type=script&lang=js"
script.render = render

export default script